<template>
    <div class="">
        <div class="about-detail">
            <div class="ad-header"></div>
            <div class="ad-box mt-f ab-1">
                <div class="ad-title">关于点点</div>
                <p class="ad-mt"><b>·点点</b>，国内领先的智能生活金融服务平台，旨为中国消费者提供最优质的综合生活与金融连接服务，已与国内众多知名金融机构达成深度合作。</p>
                <!-- <p><b>·众安保险</b>，为点点的深度战略合作伙伴。众安（股票代码:HK06060）是由蚂蚁金服、腾讯与中国平安发起设立，并为点点用户提供全面账户信息安全保障服务。</p> -->
            </div>
            <div class="ad-box ab-2 mt-25">
                <div class="ad-title">了解点点</div>
                <ul class="ad-info">
                    <li>
                        <div class="ad-icon"><div class="ad-pic"></div></div>
                        <div class="ad-test">
                            <h2>方便一点</h2>
                            <p>额度高至20万,日费率低至0.02%,快至一秒审核三秒放款,为应急解忧</p>
                        </div>
                    </li>
                    <li>
                        <div class="ad-icon"><div class="ad-pic"></div></div>
                        <div class="ad-test">
                            <h2>安全一点</h2>
                            <p>众安深度战略合作,拒绝高利贷,保障账户安全</p>
                        </div>
                    </li>
                    <li>
                        <div class="ad-icon"><div class="ad-pic"></div></div>
                        <div class="ad-test">
                            <h2>品质一点</h2>
                            <p>精选稀缺商品、分期免息买好物,助力品质生活</p>
                        </div>
                    </li>
                    <li>
                        <div class="ad-icon"><div class="ad-pic"></div></div>
                        <div class="ad-test">
                            <h2>实惠一点</h2>
                            <p>各类优惠券、免息券拿到手软,积分兑换、促销活动天天办</p>
                        </div>
                    </li>
                    <li>
                        <div class="ad-icon"><div class="ad-pic"></div></div>
                        <div class="ad-test">
                            <h2>丰富一点</h2>
                            <p>可还信用卡、可线下消费,想你所想一站式服务</p>
                        </div>
                    </li>
                    <li>
                        <div class="ad-icon"><div class="ad-pic"></div></div>
                        <div class="ad-test">
                            <h2>便利一点</h2>
                            <p>充值缴费、看电影……足不出户便利生活</p>
                        </div>
                    </li>
                </ul>
            </div>
            <p style="padding:20px;text-align:center;font-size:12px;color:grey">copyright ©保山施甸长江村镇银行股份有限公司</p>
            <!-- <div class="ad-footer mt-20"></div> -->
        </div>
    </div>
</template>

<style lang="scss">

</style>

<script>
    export default {
        data(){
            return {
                isVersioning:false
            }
        },
        created(){
        },
        mounted(){
            if(localStorage.getItem('appApplySwitch')=='1'){
                this.isVersioning=true
            }else{
                this.isVersioning=false
            }
        },
        beforeRouteEnter (to, from, next) {
            document.title = '关于点点'
            next()
        },
    }
</script>



// WEBPACK FOOTER //
// AboutDetail.vue?836aae56